module.exports = __webpack_public_path__ + "static/img/shuiqiang.60c3936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiqiang.png
// module id = 7Z+t
// module chunks = 21